<script>
    import SubscribeForm from "@xd/components/SubscribeForm";

    export default {
        name: "BrandFooter",
        components: {
            SubscribeForm,
        },
    };
</script>

<template>
    <div class="brand-footer">
        <div class="brand-footer__text">
            <div class="brand-footer__title">
                Следите <br />
                за новинками <br />
                коллекции
            </div>

            <div class="brand-footer__description">
                История XD&nbsp;Design продолжается! <br />
                Чтобы не&nbsp;пропустить новинки, подписывайтесь на&nbsp;нашу рассылку
            </div>

            <div class="brand-footer__subscribe">
                <subscribe-form></subscribe-form>
            </div>
        </div>

        <div class="brand-footer__image">
            <picture>
                <source
                    media="(max-width: 991px)"
                    srcset="/static/xd-design/brand-history/brand-footer--mobile.jpg"
                />
                <img src="/static/xd-design/brand-history/brand-footer.jpg" alt="" />
            </picture>
        </div>
    </div>
</template>

<style lang="scss">
    .brand-footer {
        color: #fff;
        background-color: #000000;
        overflow: hidden;
        @include bp($bp-desktop-sm) {
            position: relative;
            padding: 110px 0 60px calc((100vw - 1260px) / 2);
        }
    }

    .brand-footer__text {
        padding: 32px 8.88% 24px 8.88%;
        @include bp($bp-desktop-sm) {
            position: relative;
            z-index: 1;
            padding: 0;
        }
    }

    .brand-footer__image {
        position: relative;
        padding-bottom: 111%;
        img {
            @include center-absolute(0);
            width: 100%;
        }
        @include bp($bp-desktop-sm) {
            position: absolute;
            top: 0;
            right: 0;
            width: 784px;
            padding-bottom: 0;
        }
    }

    .brand-footer__title {
        margin-bottom: 32px;
        margin-right: -50px;
        font-size: 40px;
        font-weight: 100;
        line-height: 44px;
        text-transform: uppercase;
        @include bp($bp-desktop-sm) {
            margin-right: 0;
            font-size: 116px;
            font-weight: 100;
            line-height: 120px;
        }
    }

    .brand-footer__description {
        margin-bottom: 24px;
        font-size: 14px;
        font-weight: 300;
        line-height: 28px;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
        }
    }

    .brand-footer__subscribe {
        max-width: 540px;
    }
</style>
